// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import ArrowDownLineSvg from '@rsuite/icon-font/lib/direction/ArrowDownLine';
var ArrowDownLine = createSvgIcon({
  as: ArrowDownLineSvg,
  ariaLabel: 'arrow down line',
  category: 'direction',
  displayName: 'ArrowDownLine'
});
export default ArrowDownLine;